import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { PostApiRequest, ProductDetailsParams } from './postApiRequestHelper'

Vue.use(Vuex)

export interface SocialStreamPostState {
    dataLoading: boolean,
    catalogId: string,
    postId: string,
    postData: any,
}

const getInitialState = (): SocialStreamPostState => ({
    dataLoading: true,
    catalogId: '',
    postId: '',
    postData: null
})

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setDataLoading(state: SocialStreamPostState, dataLoading: boolean) {
        state.dataLoading = dataLoading
    },
    setCatalogId(state: SocialStreamPostState, catalogId: string) {
        state.catalogId = catalogId
    },
    setPostId(state: SocialStreamPostState, postId: string) {
        state.postId = postId
    },
    setPostData(state: SocialStreamPostState, data: any) {
        state.postData = data
    }
  },
  actions: {
    getPostData(context: any) {
        PostApiRequest.getPost({
            catalogId: context.state.catalogId,
            productId: context.state.postId,
        }).then(results => {
            context.commit('setPostData', results.data)
            context.commit('setDataLoading', false)
        })
    }
  }
})

